module.exports = __webpack_public_path__ + "media/images/icon__search--rb-gray@2x-abf85f79b35bc4b0c0ddc97cfbd90fa7.png";